import { useCallback, useMemo } from "react";

import { parseTaskFilter, serializeTaskFilter } from "helpers/taskFilterSerialization";
import usePersistedState from "hooks/usePersistedState";
import type { TaskFilter } from "types";

type Args = {
  localStorageKey: string;
};

type Return = {
  taskFilter: TaskFilter;
  setTaskVisibility: (newTaskFilter: TaskFilter) => void;
};

const useTaskFilter = ({ localStorageKey }: Args): Return => {
  const [persistedValue, setPersistedValue] = usePersistedState<string | null>({
    key: localStorageKey,
    defaultValue: null
  });

  const taskFilter = useMemo(() => parseTaskFilter(persistedValue), [persistedValue]);

  // Stable identity: `HeaderMobile` keeps it in the dep array of the popover it renders.
  const setTaskVisibility = useCallback(
    (newTaskFilter: TaskFilter) => {
      setPersistedValue(serializeTaskFilter(newTaskFilter));
    },
    [setPersistedValue]
  );

  return {
    taskFilter,
    setTaskVisibility
  };
};

export default useTaskFilter;
